define(["jquery", "wcs.context"], function($, ctx) {

  var isKiosk = ctx.getCookie("cn3"),
  kioskIdCookie = ctx.getCookie("kiosk_id");
  
  if(isKiosk === '1' && typeof kioskIdCookie !== 'undefined') {
   init();
  }

});

var hideSignInOptions = function() {
  var elements = [
    '.unav-myaccount', // sign in navigation
    '.unav-signing', // sign out navigation
    '.checkout-login-or-register', //sign in/create account on Shipping page
    '.checkout-login', //sign in on Shipping page
    '.product-loyalty-member-container', //sign in/create account on PDP
    '.checkout-confirmation-order-content-summary' //sign in/create account Order Conf Page
  ];

  $(elements.toString()).remove();
};

var init = function() {
  hideSignInOptions();
};
